package top.wcpe.allincore.dsl.compiler.semantic

import top.wcpe.allincore.dsl.compiler.ast.ScreenAst
import top.wcpe.allincore.dsl.compiler.diag.DiagnosticCollector
import top.wcpe.allincore.dsl.compiler.diag.DslError

/**
 * 收集 state 字段与 action 名到 [Scope]，并报告重复声明。
 *
 * 重复声明不会阻止后续阶段执行——只丢弃后续重复条目，第一条声明保留为合法符号，
 * 这样后续 ReferenceResolver 仍能完成尽量多的引用检查。
 */
class ScopeBuilder(private val diag: DiagnosticCollector) {

    fun build(screen: ScreenAst): Scope {
        val scope = Scope()

        // state defaults 字段
        screen.state?.entries?.forEach { entry ->
            if (!scope.stateNames.add(entry.name)) {
                diag.error(DslError.E101_DUPLICATE_STATE_FIELD, entry.position, entry.name)
            }
        }

        screen.model?.params?.entries?.forEach { entry ->
            if (!scope.paramNames.add(entry.name)) {
                diag.error(DslError.E101_DUPLICATE_STATE_FIELD, entry.position, "params.${entry.name}")
            }
        }

        // derived defaults 派生值：与 state 同命名空间，重名（含与 state 冲突）即报错。
        screen.derived?.entries?.forEach { entry ->
            if (entry.name in scope.stateNames || !scope.derivedNames.add(entry.name)) {
                diag.error(DslError.E101_DUPLICATE_STATE_FIELD, entry.position, entry.name)
            }
        }

        // animation 列表
        screen.animations.forEach { animation ->
            if (!scope.animationNames.add(animation.id)) {
                diag.error(DslError.E103_DUPLICATE_ANIMATION, animation.position, animation.id)
            }
        }

        // screen 级 fun 列表（C4）：与 animations 平级，重名即报错
        screen.funs.forEach { fn ->
            if (scope.funNames.add(fn.name)) {
                scope.funParamCounts[fn.name] = fn.params.size
            } else {
                diag.error(DslError.E104_DUPLICATE_FUN, fn.position, fn.name)
            }
        }

        return scope
    }
}
